export default "__VITE_ASSET__e18509ac__"